import { RawDraftContentState } from 'draft-js';

export const hasRawDraftContentText = (
  content: RawDraftContentState,
): boolean => {
  const contentBlocks = content.blocks ?? [];

  return contentBlocks.some((block) => block.text.length > 0);
};
